import { Controller } from '@hotwired/stimulus'

/**
 * Navigates the closest turbo-frame when the page size select changes.
 * Replaces the form-based auto-submit approach to avoid nested <form> issues.
 */
export default class PageSizeSelectController extends Controller {
  static values = { url: String }

  navigate() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('per_page', this.element.value)

    this.element.disabled = true
    this.element.setAttribute('aria-busy', 'true')

    this.element.closest('turbo-frame').src = url.toString()
  }
}
